<div *ngIf="canShowTooltip" class="cell-tooltip-value">
    {{ tooltipValue }}
</div>
